import { c as _c } from "react/compiler-runtime";
import { useSubscribedCouponWalletCollection } from './useSubscribedCouponWalletCollection.js';
/**
 * Gets the view model representation of a given wallet collection.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @returns Coupon model without boards
 */
export function useCouponWallets(t0) {
  const $ = _c(2);
  const {
    couponId
  } = t0;
  let t1;
  if ($[0] !== couponId) {
    t1 = {
      couponId,
      selector: _temp
    };
    $[0] = couponId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const wallet = useSubscribedCouponWalletCollection(t1);
  return wallet;
}
function _temp(wallets) {
  if (!wallets) {
    return;
  }
  return wallets;
}